import {
    customerLevels,
    publishNotifications,
    tagSearchOptions,
    timepickerModeOptions,
    userTypes
} from './variables';

export default class User {
    constructor(data = {}) {
        this.update({...data});
    }
    update({
        id,
        email,
        language,
        firstName,
        lastName,
        profilePicture,
        removePicture,
        cropperImg,
        cropperWidth,
        cropperHeight,
        cropperX,
        cropperY,
        cropperOriginal,
        isDemo,
        isLdap,
        isExternal,
        isSuperadmin,
        totpActive,
        tagSearch,
        timepickerMode,
        suppressEmails,
        password,
        passwordConfirmation,
        active,
        activeProject,
        createdAt,
        customerExternalId,
        customerName,
        lastSeenAt,
        lastLoginSupport,
        lastTransmittedLevelSupport,
        level,
        updatedAt,
        socialiteProvider,
   }) {
        this.id = id || 0;
        this.email = email || '';
        this.language = language || '';
        this.firstName = firstName || '';
        this.lastName = lastName || '';
        this.profilePicture = profilePicture || '';
        this.removePicture = removePicture || false;
        this.cropperImg = cropperImg || '';
        this.cropperWidth = cropperWidth || 0;
        this.cropperHeight = cropperHeight || 0;
        this.cropperX = cropperX || 0;
        this.cropperY = cropperY || 0;
        this.cropperOriginal = cropperOriginal || '';
        this.isDemo = isDemo || false;
        this.isLdap = isLdap || false;
        this.isExternal = isExternal || false;
        this.isSuperadmin = isSuperadmin || false;
        this.totpActive = totpActive || false;
        this.tagSearch = tagSearch ?? undefined;
        this.timepickerMode = timepickerMode ?? undefined;
        this.suppressEmails = suppressEmails ?? undefined;
        this.password = password || '';
        this.passwordConfirmation = passwordConfirmation || '';
        this.active = active || '';
        this.activeProject = activeProject || '';
        this.createdAt = createdAt || '';
        this.customerExternalId = customerExternalId ?? undefined;
        this.customerName = customerName || '';
        this.lastSeenAt = lastSeenAt || '';
        this.lastLoginSupport = lastLoginSupport || '';
        this.lastTransmittedLevelSupport = lastTransmittedLevelSupport || '';
        this.level = level || '';
        this.updatedAt = updatedAt || '';
        this.socialiteProvider = socialiteProvider || '';
        this.isLinked = false;
    }

    levels = customerLevels;
    types = userTypes;

    getUserTypes() {
        return this.types;
    }

    getLevelDisplayTexts() {
        return customerLevels.map(level => level.text);
    }

    getPublishNotificationDisplayText() {
        return publishNotifications
            .find(item => item.value === this.suppressEmails)
            .text;
    }
    getTagSearchDisplayText() {
        return tagSearchOptions[this.tagSearch].text;
    }
    getTimepickerModeDisplayText() {
        return timepickerModeOptions[this.timepickerMode].text;
    }
    removePw() {
        this.password = '';
        this.passwordConfirmation = '';
    }
    deletePicture() {
        this.profilePicture = null;
        this.removePicture = true;
    }
    updateCropperImage(image) {
        this.cropperImg = image.file || '';
        this.cropperWidth = image.width || 0;
        this.cropperHeight = image.height || 0;
        this.cropperX = image.x || 0;
        this.cropperY = image.y || 0;
        this.cropperOriginal = image.original || '';
    }

    getPayload() {
        const user = {
            id: this.id,
            email: this.email,
            language: this.language,
            firstName: this.firstName,
            lastName: this.lastName,
            profilePicture: this.profilePicture,
            removePicture: this.removePicture,
            cropperImg: this.cropperImg,
            cropperWidth: this.cropperWidth,
            cropperHeight: this.cropperHeight,
            cropperX: this.cropperX,
            cropperY: this.cropperY,
            cropperOriginal: this.cropperOriginal,
            isDemo: this.isDemo,
            isLdap: this.isLdap,
            //totpActive,
            tagSearch: this.tagSearch,
            timepickerMode: this.timepickerMode,
            suppressEmails: this.suppressEmails,
            //password,
            //passwordConfirmation,
            active: this.active,
            activeProject: this.activeProject,
            createdAt: this.createdAt,
            customerExternalId: this.customerExternalId,
            customerName: this.customerName,
            lastSeenAt: this.lastSeenAt,
            lastLoginSupport: this.lastLoginSupport,
            lastTransmittedLevelSupport: this.lastTransmittedLevelSupport,
            level: this.level,
            updatedAt: this.updatedAt
        };

        if(this.password) {
            user.password = this.password;
        }

        if(this.passwordConfirmation) {
            user.passwordConfirmation = this.passwordConfirmation;
        }

        return user;
    }
}
